// 英文语言包
export default {
  nav: {
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    about: 'About Us',
    contact: 'Contact Us'
  },
  common: {
    contactUs: 'Contact Us',
    logoText: 'Smart Security',
    language: 'Language',
    chinese: '中文',
    english: 'English'
  }
}